export default __webpack_public_path__ + "static/media/client1.480593c1.png";